import { render, staticRenderFns } from "./register-content.vue?vue&type=template&id=2ed900f0&scoped=true&"
import script from "./register-content.vue?vue&type=script&lang=js&"
export * from "./register-content.vue?vue&type=script&lang=js&"
import style0 from "./register-content.vue?vue&type=style&index=0&id=2ed900f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed900f0",
  null
  
)

export default component.exports